export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const ADMIN = '/admin';
export const PASSWORD_FORGET = '/pw-forget';
export const TERMS = '/terms';
export const PRIVACY = '/privacy';

export const GAMES = '/games';

export const APPOINTMENT = '/appointment';
export const APPOINTMENT_DISPLAY = '/appointmentDisplay';

export const STATUS = '/status';
export const ORDERS = '/orders';
export const VOUCHERS = '/vouchers';
export const DISPLAY = '/display';
export const SA = '/sa';
export const MAP = '/map';
export const BOARD = '/board';
export const INPUTJPCB = '/input-jpcb';
export const HISTORY = '/history';

export const ANTRIAN = '/antrian';
export const DISPLAY_ANTRIAN = '/display-antrian';

export const TOOL_WHATSAPP_LINK = '/tools/whatsapplink';
export const TOOL_ROBO_CONTACT = '/tools/robocontact';
export const TOOL_CARI_IKLAN = '/tools/cariiklan';
export const PROMO = '/promo';

export const BLAST = '/blast';
